import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material'; // Assuming you're using MUI for styling
import BrandSideLogo from '@/components/BrandSideLogo'; // Adjust according to your project structure
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function AuthLayout() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.auth);
  const accessToken = localStorage.getItem('access_token');
  const role = localStorage.getItem('role');

  useEffect(() => {
    if (user && accessToken) {
      const currentPath = window.location.pathname;
      console.log(currentPath);
      const dashboardRoute = role === 'customer' ? '/customer/search-brokers' : '/vendor/dashboard';
      if(currentPath === '/customer/auth/login' || currentPath === '/vendor/auth/login') {
        navigate(dashboardRoute, { replace: true });
      }
      else{
        navigate(currentPath, { replace: true });
      }
    }
  }, [user, accessToken, role, navigate]);
  return (
    <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} width="100%" height="100vh">
      {/* Left side of the layout - Brand/Logo section */}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex="1"
        bgcolor="primary.main" // Adjust the background color as needed
        color="white"
        width="100%"
      >
        <BrandSideLogo /> {/* Adjust this component to display your logo */}
      </Box>

      {/* Right side of the layout - Authentication forms */}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex="1"
        bgcolor="background.default" // Adjust the background color as needed
      >
        {/* Toast notifications */}
        <ToastContainer />

        {/* Render the child components here */}
        <Outlet />
      </Box>
    </Box>
  );
};

